import type { Role } from "@coup/shared";
import { ROLE_ART } from "../art";
import { Icon } from "./Icon";
import styles from "./RoleChip.module.css";

interface Props {
  role: Role;
  size?: "sm" | "md";
  prefix?: string;
}

export function RoleChip({ role, size = "md", prefix }: Props) {
  const art = ROLE_ART[role];
  return (
    <span className={`${styles.chip} ${styles[size]}`} style={{ background: art.color }}>
      <Icon path={art.icon} size={size === "sm" ? 11 : 13} color="#efe6d2" />
      {prefix}
      {art.name}
    </span>
  );
}
